<template>
  <router-link
    class="nav-icon-group h-full justify-center flex flex-col items-center"
    :class="{ active: isActive, mobile: isMobile }"
    :aria-current="isActive ? 'page' : undefined"
    :tabindex="linkTabIndex"
    :to="to"
  >
    <div class="relative">
      <Badge v-if="badgeNum > 0" :badgeContent="badgeNum" class="absolute left-[1.1rem] -top-4 md:-top-6 md:ml-0" />
      <slot />
    </div>
    <p class="text-caption">{{ text }}</p>
  </router-link>
</template>

<script lang="ts">
import Badge from '@/components/badge/Badge.vue';

export default {
  name: 'NavigationItem',
  components: {
    Badge,
  },
  props: {
    to: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
    badgeNum: {
      type: Number,
      required: false,
      default: 0,
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
    isMobile: {
      type: Boolean,
      required: false,
      default: false,
    },
    linkTabIndex: {
      type: Number,
      required: false,
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-icon-group {
  border: 2px solid var(--light-surface-foreground, #fff);
  width: 80px;

  &:focus-visible {
    outline: none;
    border: 2px dotted var(--color-brand-contrast);
  }

  // pink hover on desktop only
  &:not(.mobile):hover {
    border-color: var(--color-grey-bg-contrast);
    background-color: var(--color-grey-bg-contrast);
    cursor: pointer;
    color: var(--color-brand-contrast);
  }

  &.active.mobile:focus-visible {
    border-bottom-color: var(--color-brand-contrast);
  }

  &.active:not(:focus-visible) {
    border-bottom-color: var(--on-surface-headers, #05070f);

    &:not(.mobile):hover {
      border-bottom-color: var(--color-brand-contrast);
    }

    &.mobile {
      border-top-color: var(--on-surface-headers, #05070f);
      border-bottom-color: var(--color-white);
    }
  }
}
</style>
